export const NO_COMPANY = -1;
